export default "__VITE_ASSET__fbd30103__"